import "./styles/app.css";
import { useEffect } from "react";

import RegistrationPage from "./features/registration";

import { useLanguageStore } from "@/store/languageStore.ts";
import { detectBrowserLanguage } from "@/localization/detectLanguage.ts";

const App = () => {
	const { setLang } = useLanguageStore();

	useEffect(() => {
		setLang(detectBrowserLanguage());
	}, [setLang]);

	return <RegistrationPage />;
};

export default App;
